(() => {
  const SKIP_TAGS = new Set(["SCRIPT","STYLE","NOSCRIPT","TEXTAREA","INPUT","SELECT","OPTION"]);
  const SKIP_ATTR = "data-no-ridge-x";

  // Match RidgeX, Ridge X, RIDGEX, RIDGE X (and also swallow any spaces after X)
  const RX = /\b(Ridge|RIDGE)\s*X\s*/g;

  function shouldSkip(node) {
    const el = node.parentElement;
    if (!el) return true;
    if (SKIP_TAGS.has(el.tagName)) return true;
    if (el.closest(`[${SKIP_ATTR}]`)) return true;
    if (el.closest(".ridge-x-processed")) return true;
    return false;
  }

  function replaceTextNode(tn) {
    if (!tn || tn.nodeType !== Node.TEXT_NODE) return;
    if (shouldSkip(tn)) return;

    const text = tn.nodeValue;
    if (!text) return;

    RX.lastIndex = 0;
    if (!RX.test(text)) return;
    RX.lastIndex = 0;

    const frag = document.createDocumentFragment();
    let lastIndex = 0;

    for (const m of text.matchAll(RX)) {
      const start = m.index;
      const end = start + m[0].length;

      // text before match
      frag.appendChild(document.createTextNode(text.slice(lastIndex, start)));

      // "Ridge" (NO spaces — spacing comes from CSS margin on the X span)
      frag.appendChild(document.createTextNode(m[1]));

      // the X span
      const span = document.createElement("span");
      span.className = "ridge-x__x ridge-x-processed";
      span.textContent = "X";
      frag.appendChild(span);

      lastIndex = end;
    }

    // remaining text after last match
    frag.appendChild(document.createTextNode(text.slice(lastIndex)));

    tn.parentNode.replaceChild(frag, tn);
  }

  function walk(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue || node.nodeValue.trim() === "") return NodeFilter.FILTER_REJECT;
          if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
          // cheap prefilter
          if (node.nodeValue.includes("Ridge") || node.nodeValue.includes("RIDGE")) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceTextNode);
  }

  function init() {
    walk(document.body);

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType === Node.ELEMENT_NODE) walk(n);
        }
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();